import { render, staticRenderFns } from "./AdminNav.vue?vue&type=template&id=f81453aa&scoped=true"
import script from "./AdminNav.vue?vue&type=script&lang=js"
export * from "./AdminNav.vue?vue&type=script&lang=js"
import style0 from "./AdminNav.vue?vue&type=style&index=0&id=f81453aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81453aa",
  null
  
)

export default component.exports